import styled from 'styled-components';

export const MenuWrapper = styled.div``

export const MenuList = styled.ul`
    list-style-type: none;
    padding: 0px;
`

export const MenuItem = styled.li`
    margin-bottom: 10px;
    position: relative;
`